import React, { useEffect, useState } from 'react';
import { BringzzBoxSlider, BringzzButton, BringzzOrder, BringzzText } from "@bringzz/components";
import { useNavigation } from 'context/NavigationContext';
import {
    BringzzPageContainer,
    BringzzIcon,
    BringzzOrderCard
} from "@bringzz/components";
import useRequest from 'hooks/useRequest';
import { ORDER_STATUS } from 'utils/constants';

const CompletedOrdersPage = () => {
    const { backPress } = useNavigation();

    const { navigate } = useNavigation();
    const { sendRequest, loading } = useRequest();
    const [orders, setOrders] = useState([])

    const parseDate = (dateString) => {
        const [datePart, timePart] = dateString.split(' ');
        const [day, month, year] = datePart.split('.');
        const [hours, minutes] = timePart.split(':');
        return new Date(year, month - 1, day, hours, minutes);
    };

    const fetchOrders = async () => {
        await sendRequest({
            method: 'GET',
            url: `/module/order/getAllOrders`,
        }).then((response) => {
            if (response.status === 'success') {
                const completedOrders = response.data
                    .filter(order => order.deliveryStatus === ORDER_STATUS.DONE)
                    .map(order => ({
                        ...order,
                        orderdate: parseDate(order.created)
                    }));
                setOrders(completedOrders);
            }
        }).catch((error) => {
            console.error(error);
        })
    }

    useEffect(() => {
        fetchOrders()
    }, [])

    return (
        <BringzzPageContainer
            className="bg-white"
            header={{
                left: (
                    <BringzzIcon
                        size='22'
                        icon='IconChevronLeft'
                        folder='LineIcons'
                        className='cursor-pointer'
                        onClick={backPress}
                    />
                ),
                title: "Completed Orders"
            }}
            authenticated={true}
        >
            <div>
                {orders.length > 0 &&
                    <div className='px-6 pb-8'>
                        <div className='py-4 space-y-4'>
                            {orders.map(((order, index) => {
                                return <div key={index}>
                                    <BringzzOrderCard
                                        orderDetails={{
                                            name: order.customerName,
                                            date: new Date(order.orderdate),
                                            status: 'Completed',
                                            price: order.price,
                                            itemsCount: order.products.length
                                        }}
                                        onClick={() => navigate(`/settings/pharmacy/orders/view/${order.integrationId}`)}
                                    ></BringzzOrderCard>
                                </div>
                            }))}
                        </div>
                    </div>
                }
            </div>
        </BringzzPageContainer >
    );
};

export default CompletedOrdersPage;
